if (!window.customElements.get("recently-viewed-products")) {
class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0.2 });
    }

    connectedCallback() {
        this.observer.observe(this);
    }

    async onIntersect(entries) {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                this.observer.unobserve(entry.target);
                const query = this.buildQuery();
                if (query) {
                    this.loadProducts(query);
                }
            }
        }
    }

    buildQuery() {
        try {
            const items = JSON.parse(localStorage.getItem("recently-viewed") || "[]");
            if (!Array.isArray(items)) return "";
            const excludeId = Number(this.getAttribute("exclude-id"));
            return [...new Set(items.map(Number))]
                .filter(id => Number.isSafeInteger(id) && id > 0 && id !== excludeId)
                .slice(0, 50)
                .map(id => `id:${id}`).join(" OR ");
        } catch {
            return "";
        }
    }

    async loadProducts(query) {
        try {
            const params = new URLSearchParams({ q: query, type: "product", section_id: this.sectionId });
            const response = await fetch(`${theme.routes.root_url}search?${params}`);
            if (!response.ok) return;
            const html = await response.text();
            const products = new DOMParser().parseFromString(html, 'text/html').querySelector("recently-viewed-products");
            if (!products) return;
            const audience = this.getAttribute("product-gender");
            let visibleCount = 0;
            products.querySelectorAll("[data-recent-product]").forEach(card => {
                const cardAudience = card.getAttribute("data-product-gender");
                const matchesAudience = !["homme", "femme"].includes(audience)
                    || cardAudience === audience || cardAudience === "unisexe";
                if (!matchesAudience || visibleCount >= this.productLimit) {
                    card.remove();
                } else {
                    visibleCount += 1;
                    card.style.setProperty("--animation-order", visibleCount);
                }
            });
            this.innerHTML = visibleCount ? products.innerHTML : "";
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    }

    get sectionId() {
        return this.getAttribute("section-id");
    }

    get productLimit() {
        return parseInt(this.getAttribute("products-limit")) || 4;
    }
}

window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

